<template>
  <div>
    <template v-for="(item, index) in items">
      <!-- Leaf item (no children) -->
      <div
        v-if="!item.children"
        :key="`leaf-${index}`"
        class="sidebar-menu-item my-1"
      >
        <eg-button
          v-b-tooltip.hover.right="tipMethod(item.name)"
          type="ordinary"
          :to="item.href ? null : item.to"
          :href="item.href"
          :target="item.target"
          :icon="isMenuHided ? item.minimizedIcon || item.icon : item.icon"
          :class="item.class"
          :data-testid="item.testId || null"
          icon-size="medium"
          class="menu-item-button"
          size="small"
          :active="isItemActive(item)"
          @click="item.onClick && item.onClick()"
        >
          <transition name="sidebar-maximized-transition">
            <template v-if="!isMenuHided">
              <span>{{ item.name }}</span>
            </template>
          </transition>
        </eg-button>
      </div>

      <!-- Collapsible item (has children) — renders recursively -->
      <eg-collapsible-item
        v-else
        :key="`group-${index}`"
        :ref="item.ref || `group-${index}`"
        :label="item.name"
        :icon="item.icon"
        :button-class="item.class"
        :is-menu-hided="isMenuHided"
        :initial-expanded="isExpanded(item)"
        :tooltip="tipMethod(item.name)"
        @toggle="handleGroupToggle(index, $event)"
      >
        <sidebar-menu-items
          :items="item.children"
          :is-menu-hided="isMenuHided"
        />
      </eg-collapsible-item>
    </template>
  </div>
</template>

<script>
import EgCollapsibleItem from "@/components/global/sidebar/eg_collapsible_item.vue";
import sidebarAccordionMixin from "@/mixins/sidebarAccordionMixin";

export default {
  name: "SidebarMenuItems",

  components: {
    EgCollapsibleItem,
  },

  mixins: [sidebarAccordionMixin],

  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    isMenuHided: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    currentRoute() {
      return this.$route.path;
    },

    accordionItems() {
      return this.items;
    },
  },

  methods: {
    getItemByRef(refName) {
      const ref = this.$refs[refName];
      return Array.isArray(ref) ? ref[0] : ref;
    },

    openItem(refName) {
      this.getItemByRef(refName)?.open();
    },

    closeItem(refName) {
      this.getItemByRef(refName)?.close();
    },

    tipMethod(title) {
      return this.isMenuHided ? title : "";
    },

    isItemActive(item) {
      if (!item.activeMatcher) return false;
      return item.activeMatcher(this.currentRoute);
    },

    isExpanded(item) {
      if (!item.children) return false;

      return item.children.some(
        (child) =>
          this.currentRoute === child.to ||
          (child.activeMatcher && child.activeMatcher(this.currentRoute)) ||
          (child.children && this.isExpanded(child))
      );
    },
  },
};
</script>
